var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-new-wrapper"},[_c('span',{staticClass:"transition cursor-pointer duration-200 rounded button icon-plus icon-plus-right bg-white/25 flex-1",class:[_vm.disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''],on:{"click":_vm.click}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }